import {SignaturePad} from "angular2-signaturepad";
import {Component, ViewChild} from "@angular/core";

@Component({
  selector: 'app-draw-select',
  templateUrl: './draw.component.html',
  styleUrls: []
})

export class DrawComponent {

  @ViewChild(SignaturePad) signaturePad: SignaturePad;

  signaturePadOptions: Object = { // passed through to szimek/signature_pad constructor
    dotSize: function () {
      return (0.5 + 1.5) / 2;
    },
    minWidth: 0.5,
    maxWidth: 1.5,
    canvasWidth: 500,
    canvasHeight: 300,
    velocityFilterWeight: 0.7,
    backgroundColor: 'rgb(255,255,255)',
    throttle: 0
  };

  constructor() {
  }

  ngAfterViewInit() {
    this.signaturePad.set('minWidth', 5);
    this.signaturePad.clear();
  }

  drawComplete() {
    console.log(this.signaturePad.toDataURL());
  }

  drawStart() {
    console.log('begin drawing');
  }

  clear() {
    this.signaturePad.clear();
  }
}
